import React, { useEffect, useState } from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import SchoolIcon from "@mui/icons-material/School";
import { client } from "../../client";
const Education = () => {
  const [education, setEducation] = useState([]);

  useEffect(() => {
    const query = `*[_type == "educationsection"]{
      collegename,
      yopass,
      universityname,
      qualificationname,
          
            
        } | order(yopass desc)`;

    client.fetch(query).then((data) => {
      setEducation(data);
    });
  }, []);

  return (
    <VerticalTimeline layout="1-column-left">
      {education &&
        education.map((edudata, edukey) => (
          <VerticalTimelineElement
            key={edukey}
            className="vertical-timeline-element--work"
            contentStyle={{ background: "#29172d", color: "#fff" }}
            contentArrowStyle={{ borderRight: "7px solid  #29172d" }}
            date={edudata.yopass}
            iconStyle={{ background: "#29172d", color: "#fff" }}
            icon={<SchoolIcon />}
            position="right"
          >
            <h3 className="vertical-timeline-element-title">
              {edudata.qualificationname}
            </h3>
           
            <p>
              {edudata.collegename}.
            </p>
            <p>
              {edudata.universityname}.
            </p>
          </VerticalTimelineElement>
        ))}
    </VerticalTimeline>
  );
};

export default Education;
